
import { useEffect } from 'react';
import { Icon } from '@/components/ui/icon';

/**
 * NodeError - Error display component with auto-dismiss
 *
 * Features:
 * - Positioned outside node card (bottom-left)
 * - Auto-dismisses after 5 seconds
 * - Manual dismiss with X button
 * - Overlay positioning (no layout shift)
 */
interface NodeErrorProps {
  message?: string;
  onDismiss?: () => void;
}

export function NodeError({ message, onDismiss }: NodeErrorProps) {
  // Auto-dismiss after 5 seconds
  useEffect(() => {
    if (message && onDismiss) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, onDismiss]);

  if (!message) return null;

  return (
    <div className="absolute -bottom-12 left-0 right-0 z-10">
      <div className="flex items-start gap-2 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800 dark:border-red-800 dark:bg-red-950/20 dark:text-red-400">
        <Icon name="alert-circle" className="mt-0.5 h-4 w-4 flex-shrink-0" />
        <p className="flex-1">{message}</p>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="flex-shrink-0 text-red-800 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300"
          >
            <Icon name="x" className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
